import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { AddMeetingModel } from "models/AddMeetingModel";
import { MeetingDetailModel } from "models/MeetingDetailModel";
import { MeetingModel } from "models/MeetingModel";
import { PatchMeetingModel } from "models/PatchMeetingModel";
import { SiveActionResult } from "models/SiveActionResult";

export class MeetingApi {
  constructor(private axios: AxiosInstance) {}

  async getTemplates() {
    const url = getBoardApiUrl("templates");
    const response = await this.axios.get(url);
    return response.data;
  }

  async getItem(meetingId: number, signal?: AbortSignal) {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`meetings/${meetingId}`);
    const response = await this.axios.get<MeetingModel>(url, { signal });
    return response.data;
  }

  async getDetail(meetingId: number, signal?: AbortSignal) {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`meetings/${meetingId}/detailed`);
    const response = await this.axios.get<MeetingDetailModel>(url, { signal });
    return response.data;
  }

  async update(patch: PatchMeetingModel) {
    const { id: meetingId } = patch;
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`meetings/${meetingId}`);
    const response = await this.axios.patch<SiveActionResult>(url, patch);
    return response.data;
  }

  async add(patch: AddMeetingModel): Promise<SiveActionResult> {
    const url = getBoardApiUrl(`meetings`);
    const response = await this.axios.post<SiveActionResult>(url, patch);
    return response.data;
  }

  async delete(meetingId: number): Promise<SiveActionResult> {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`meetings/${meetingId}`);
    const response = await this.axios.delete<SiveActionResult>(url);
    return response.data;
  }
}
